import React, { useState } from "react";
import Classes from "./AppointmentTabs.module.css";
import AppointmentDetails from "./AppointmentDetail";
import ClientDetails from "./ClientDetail";
import VehicleDetails from "./VehicleDetail";

export default function AppointmentTabs({ booking, refresh }) {
  const [tab, setTab] = useState("appointment");

  return (
    <div className={Classes.wrap}>
      <div className={Classes.tabs}>
        <button className={`${Classes.tab} ${tab === "appointment" ? Classes.active : ""}`} onClick={() => setTab("appointment")}>Appointment</button>
        <button className={`${Classes.tab} ${tab === "client" ? Classes.active : ""}`} onClick={() => setTab("client")}>Client</button>
        <button className={`${Classes.tab} ${tab === "vehicles" ? Classes.active : ""}`} onClick={() => setTab("vehicles")}>Vehicles</button>
      </div>

      {tab === "appointment" && <AppointmentDetails booking={booking} refresh={refresh} />}
      {tab === "client" && <ClientDetails booking={booking} />}
      {tab === "vehicles" && <VehicleDetails booking={booking} />}
    </div>
  );
}
